// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2rOFs","productName":"Table_productName__18Loy"};